
import React from 'react';

export const ArrowLeftIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    arrow_back
  </span>
);